import {
    ADMIN_TRANSFER_TYPE_MAPPING_SUCCESS,
    ADMIN_TRANSFER_TYPE_MAPPING_FAILED,
    RESET_ADMIN_TRANSFER_TYPE_MAPPING,
    LOADING_ADMIN_TRANSFER_TYPE_MAPPING,
    NETWORK_ERROR_ADMIN_TRANSFER_TYPE_MAPPING
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetadminTransferTypeMappping = () => {
    return { type: RESET_ADMIN_TRANSFER_TYPE_MAPPING };
};

const adminTransferTypeMappping = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADMIN_TRANSFER_TYPE_MAPPING });
    await adminServices
        .post("transferTypeMapping", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch({ type: ADMIN_TRANSFER_TYPE_MAPPING_SUCCESS, payload: res.data });
                    break;
                default:
                    dispatch({ type: ADMIN_TRANSFER_TYPE_MAPPING_FAILED, payload: res.data });
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_ADMIN_TRANSFER_TYPE_MAPPING,
                payload: err
            });
        });
};

export { adminTransferTypeMappping, resetadminTransferTypeMappping };
